import { Row } from 'antd';
import React, { useContext } from 'react';
import PosCard from './components/PosCard';
import { useLoaderData } from 'react-router-dom';
import AuthContext from '../utils/AuthContext';




const Overview = () => {
  const posSessions = useLoaderData();
  const {user} = useContext(AuthContext);
  // console.log(posSessions)
  // console.log(posSessions);
  return (
    <div>
      <Row>
        {posSessions.map(pos => <PosCard key={pos.id} id={pos.id} pos_name={pos.name} phone={pos.hotline} session={pos.session} user_id={user.id}/>)}
      </Row>
    </div>
  )
}

export default Overview